import { usePromoBanners } from "@faire/retailer-visitor-shared/stores/ui/usePromoBanners";
import { intlDate } from "@faire/web--source/common/localization/date-fns/intlDate";
import { Typography } from "@faire/web--source/slate/Typography";
import { Medium } from "@faire/web--source/ui/Typography/Span";
import { observer } from "mobx-react";
import * as React from "react";

const EmployeeGrantedFreeFreightBannerBase: React.FC = () => {
  const { employeeGrantedFreeFreightDeadline } = usePromoBanners();
  const deadline = intlDate(
    employeeGrantedFreeFreightDeadline ?? new Date(),
    "PPpx"
  );

  return (
    <Typography align="center">
      <Medium>You’ve got free shipping</Medium> on your next order! Expires{" "}
      <Medium>{deadline}</Medium>
    </Typography>
  );
};

export const EmployeeGrantedFreeFreightBanner = observer(
  EmployeeGrantedFreeFreightBannerBase
);
